import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { Toaster } from "./components/ui/sonner";
import { ProtectedRoute, PublicRoute, PasswordChangeRoute } from "./routes/guards";
import { routeConfig } from "./routes/routeConfig";
import { ErrorBoundary } from "./components/ErrorBoundary";

const GUARD_MAP = {
    public: (Component) => <PublicRoute><Component /></PublicRoute>,
    password: (Component) => <PasswordChangeRoute><Component /></PasswordChangeRoute>,
    mentor: (Component) => <ProtectedRoute requireRole="mentor"><Component /></ProtectedRoute>,
    usuario: (Component) => <ProtectedRoute requireRole="usuario"><Component /></ProtectedRoute>,
    open: (Component) => <Component />,
};

function AppRoutes() {
    return (
        <Routes>
            {routeConfig.map(({ path, component: Component, type }) => (
                <Route
                    key={path}
                    path={path}
                    element={GUARD_MAP[type](Component)}
                />
            ))}
            {/* Default redirect */}
            <Route path="/" element={<Navigate to="/login" replace />} />
            <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
    );
}

function App() {
    return (
        <ErrorBoundary>
            <AuthProvider>
                <BrowserRouter>
                    <Toaster position="top-right" richColors />
                    <AppRoutes />
                </BrowserRouter>
            </AuthProvider>
        </ErrorBoundary>
    );
}

export default App;
